import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { saveToIndexedDB } from "../../utils/indexedDB";

export function ImportFile() {
  const { lang, proxy, socket, auth: user } = useSelector((state) => state);
  const [statusActive, setStatusActive] = useState(false);
  const _token = localStorage.getItem("_token");
  const [file, setFile] = useState({});
  const [uploadedJson, setUploadedJson] = useState(null);
  const dispatch = useDispatch();

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const json = JSON.parse(e.target.result);
          setFile(file);
          setUploadedJson(json);
        } catch (error) {
          showAlert("faild", "format", "error");
        }
      };
      reader.readAsText(file);
    }
  };

  const showAlert = (titleKey, textKey, icon) => {
    Swal.fire({
      title: lang[titleKey],
      text: lang[textKey],
      icon: icon,
      showConfirmButton: true,
      customClass: {
        confirmButton: "swal2-confirm my-confirm-button-class",
      },
    });
  };

  const handleImport = async (url, type, data) => {
    Swal.fire({
      title: lang["importing"],
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: _token,
          Type: type,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        Swal.fire({
          title: lang["success"],
          text: lang["success.content"],
          icon: "success",
          showConfirmButton: true,
          timer: 1500,
        }).then(() => {
          window.location.reload();
        });
        return true;
      } else {
        throw new Error("Response is not ok");
      }
    } catch (error) {
      Swal.close();
      showAlert("faild", "faild.content", "error");
      return false;
    }
  };

  const importData = async () => {
    handleImport(
      `${proxy()}/versions/import/database`,
      "Database",
      uploadedJson
    );
    try {
      const response = await fetch(`${proxy()}/apis/all/tables/and/fields`, {
        headers: {
          Authorization: _token,
        },
      });
      const resp = await response.json();

      const { success, data } = resp;
      if (success && data) {
        const { tables, fields } = data;
        await saveToIndexedDB("fields", fields);
        await saveToIndexedDB("tables", tables);
        dispatch({
          branch: "db",
          type: "initializeData",
          payload: { tables, fields },
        });
      }
    } catch (error) {
      console.error("Error", error);
    }
    socket.emit("/dipe-production-import-db");
  };

  const importAPI = () => {
    handleImport(`${proxy()}/versions/import/api`, "API", uploadedJson);
    socket.emit("/dipe-production-import-api");
  };

  const importUI = async () => {
    const success = await handleImport(`${proxy()}/apis/import/ui`, "UI", {
      ui: uploadedJson,
    });
    if (success) {
      socket.emit("/dipe-production-import-ui");
      await saveToIndexedDB("pages", uploadedJson.data);
    }
  };

  const getFileType = () => {
    const { data } = uploadedJson;
    const keys = Object.keys(data);

    if (keys.includes("apis")) {
      return lang["api"];
    } else if (keys.includes("database")) {
      return lang["database"];
    } else if (Array.isArray(data)) {
      return "UI";
    } else {
      return lang["faild.format"];
    }
  };

  const CustomFileInput = ({ onChange, ...props }) => {
    const fileInputRef = useRef(null);
    const handleButtonClick = () => fileInputRef.current.click();
    const handleFileChange = (event) => {
      if (onChange) onChange(event);
    };
    return (
      <div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
          {...props}
        />
        <button
          onClick={handleButtonClick}
          className="btn btn-primary ml-2 mr-2"
        >
          {lang["select file"]}
        </button>
      </div>
    );
  };

  useEffect(() => {
    fetch(`${proxy()}/auth/activation/check`, {
      headers: {
        Authorization: _token,
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        const { activated } = resp;
        if (activated) {
          setStatusActive(true);
        } else {
          showAlert("faild", "fail.active", "error");
          setStatusActive(false);
        }
      });
  }, []);

  return (
    <div className="midde_cont">
      <div className="container-fluid">
        <div className="row column_title">
          <div className="col-md-12">
            <div className="page_title">
              <h4 className="ml-1">Import data</h4>
            </div>
          </div>
        </div>

        {statusActive && (
          <div className="row margin_top_30">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="white_shd full">
                <div className="full graph_head">
                  <div className="heading1 margin_0">
                    <h5> Import</h5>
                  </div>
                </div>
                <div
                  className="full price_table padding_infor_info"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "40vh",
                  }}
                >
                  <div
                    className="form-group col-md-12"
                    style={{ marginBottom: "auto" }}
                  >
                    <div className="col-md-12 mt-4">
                      <label>
                        <b className="font-weight-bold">{lang["file name"]}:</b>{" "}
                        {file.name}
                      </label>
                    </div>
                    <div className="col-md-12 mt-4">
                      <label>
                        <b className="font-weight-bold">{lang["type file"]}:</b>{" "}
                        {uploadedJson ? getFileType() : null}
                      </label>
                    </div>
                  </div>
                  <div
                    className="col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "auto",
                    }}
                  >
                    <CustomFileInput onChange={handleFileUpload} />
                    {uploadedJson &&
                      (getFileType() === lang["api"] ? (
                        <button
                          onClick={importAPI}
                          className="btn btn-primary ml-1"
                        >
                          Import API
                        </button>
                      ) : getFileType() === lang["database"] ? (
                        <button
                          onClick={importData}
                          className="btn btn-primary"
                        >
                          Import Database
                        </button>
                      ) : getFileType() === "UI" ? (
                        <button onClick={importUI} className="btn btn-primary">
                          Import UI
                        </button>
                      ) : null)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
